import React from "react";
import styles from "./NotificationUnsubscribe.scss";
export const NotificationUnsubscribe = () => {
  return (
    <section>
      <div className={styles.content}>
        <h2>{"Uspješno ste se odjavili sa servisa za e-mail obavijesti."}</h2>
        <p>{"Ako želite ponovo primati obavijesti, možete ih uključiti u okviru postavki Vašeg profila."}</p>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/NotificationUnsubscribe/index.tsx